import { Box, Stack, Typography } from "@mui/material"
import profileBorder from "../../common/images/profile_border.png"
import useIsMobile from "@/hooks/useIsMobile"

interface EmployeeHeadShotProps {
  image: string
  name: string
  position: string
}

export default function EmployeeHeadShot({
  image,
  name,
  position,
}: EmployeeHeadShotProps) {
  const isMobile = useIsMobile()
  return (
    <Stack
      alignItems="center"
      spacing={2}
      sx={{ paddingBottom: isMobile ? 2 : 0 }}
    >
      <Box
        sx={{
          display: "flex",
          position: "relative",
          width: isMobile ? "150px" : "250px",
          height: isMobile ? "150px" : "250px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={image}
          alt="Profile"
          sx={
            isMobile
              ? {
                  width: "125px",
                  height: "125px",
                  borderRadius: "50%",
                }
              : {
                  width: "220px",
                  height: "220px",
                  borderRadius: "50%",
                }
          }
        />
        <Box
          component="img"
          src={profileBorder}
          alt="Border"
          sx={{
            position: "absolute",
            filter: "invert(1) brightness(2)",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            zIndex: 2,
          }}
        />
      </Box>
      {/* Name and position */}
      <Stack alignItems="center">
        <Typography
          fontSize={isMobile ? 24 : 32}
          color="white"
          sx={{ textAlign: "center" }}
        >
          {name}
        </Typography>
        <Typography fontSize={isMobile ? 20 : 24} color="#05FF00">
          {position}
        </Typography>
      </Stack>
    </Stack>
  )
}
